import { render, staticRenderFns } from "./asignarunidad.vue?vue&type=template&id=5db4e491"
import script from "./asignarunidad.vue?vue&type=script&lang=js"
export * from "./asignarunidad.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports